'use es6';

import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { Table } from 'foundations-components/transitional/components/Table';
import { hasSufficientViewPermission } from '../../permissions/permission-logic';
import { getUserPermissionLevel } from '../../data/schemas/dashboardSchema';
import { getReportDashboardInfo } from '../../data/schemas/reportSchema';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Set as ImmutableSet } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ParentComponent = ({
  children,
  isTable
}) => isTable ? /*#__PURE__*/_jsx(ScrollContainer, {
  maxHeight: 200,
  children: /*#__PURE__*/_jsx(Table, {
    children: /*#__PURE__*/_jsx("tbody", {
      children: children
    })
  })
}) : /*#__PURE__*/_jsx(List, {
  styled: true,
  wrapChildren: true,
  children: children
});
const ParentDashboardList = ({
  formatAsTable,
  reports
}) => {
  const parentDashboards = reports.reduce((memo, report) => memo.union(getReportDashboardInfo(report)),
  //ensures uniqueness
  ImmutableSet()).toJS();
  const parentCount = parentDashboards.length;
  const viewableDashboards = parentDashboards.filter(dashboard => hasSufficientViewPermission(getUserPermissionLevel(dashboard)));
  const privateDashboardCount = parentCount - viewableDashboards.length;
  const ListItem = ({
    children
  }) => formatAsTable ? /*#__PURE__*/_jsx("tr", {
    children: /*#__PURE__*/_jsx("td", {
      children: children
    })
  }) : children;
  return /*#__PURE__*/_jsxs(ParentComponent, {
    isTable: formatAsTable,
    children: [viewableDashboards.map(dashboard => {
      const {
        id,
        name
      } = dashboard;
      return /*#__PURE__*/_jsx(ListItem, {
        dashboard: dashboard,
        children: /*#__PURE__*/_jsx(Link, {
          target: "_blank",
          external: true,
          href: `/reports-dashboard/${PortalIdParser.get()}/view/${id}`,
          children: name
        })
      }, `parent-dashboard-${id}`);
    }), privateDashboardCount > 0 && /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.dashboards.privateDashboards",
        options: {
          count: privateDashboardCount
        }
      })
    }, "parent-private-dashboards")]
  });
};
ParentDashboardList.propTypes = {
  formatAsTable: PropTypes.bool,
  reports: ImmutablePropTypes.set.isRequired
};
export default ParentDashboardList;